import * as PIXI from "pixi.js-legacy";

export function getSprite(name: string, x: number, y: number, anchor: object = {x: 0.5, y: 0.5}): PIXI.Sprite {
    let sprite = new PIXI.Sprite(PIXI.Texture.from(name));
    // @ts-ignore
    sprite.anchor.set(anchor.x, anchor.y);
    sprite.position.set(x, y);
    return sprite;
}

export function removeSprite(sprite: any): void {
    if (sprite && !sprite._destroyed) {
        createjs.Tween.removeTweens(sprite.scale);
        createjs.Tween.removeTweens(sprite);
        if (sprite.parent) {
            sprite.parent.removeChild(sprite);
        }
        sprite.destroy({children:true, texture:false, baseTexture:true});
    }
}